import { createContext, useState, useEffect } from "react";
import { ThemeProvider, createTheme, CssBaseline } from "@mui/material";
import lightBg from "../assets/bg/light-bg.webp";
import darkBg from "../assets/bg/dark-bg.webp";
import darkBgMob from "../assets/bg/dark-bg-mob.webp";

export const ThemeContext = createContext();

export const ThemeProviderWrapper = ({ children }) => {
  const storedTheme = localStorage.getItem("theme") || "dark";
  const [mode, setMode] = useState(storedTheme);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  useEffect(() => {
    localStorage.setItem("theme", mode);
  }, [mode]);

  const toggleTheme = () => {
    setMode((prevMode) => (prevMode === "light" ? "dark" : "light"));
  };

  const getDarkBackground = () => (isMobile ? darkBgMob : darkBg);

  const theme = createTheme({
    palette: {
      mode,
      background: {
        default: `url(${mode === "light" ? lightBg : getDarkBackground()})`,
        paper: mode === "light" ? "#ffffff" : "#1e1e1e",
      },
    },
    typography: {
      fontFamily: "'Montserrat', sans-serif",
      h4: {
        fontWeight: 300,
        fontSize: "1.8rem",
        color: mode === "light" ? "#333" : "#ddd",
      },
      h6: {
        fontWeight: 300,
        fontSize: "1.2rem",
        color: mode === "light" ? "#555" : "#bbb",
      },
      body1: {
        fontWeight: 300,
        fontSize: "1rem",
        color: mode === "light" ? "#333" : "#ccc",
      },
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            backgroundImage: `url(${mode === "light" ? lightBg : getDarkBackground()})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            minHeight: "100vh",
            width: "100%",
          },
        },
      },
    },
  });

  return (
    <ThemeContext.Provider value={{ toggleTheme, mode }}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </ThemeContext.Provider>
  );
};
